import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '@core/auth.service';
import { UserService } from '@core/user.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  currentUser: any = {};
  links: Array<any> = [];
  show = false;

  constructor(
    public authService: AuthService,
    public userService: UserService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.userService.getCurrentUser().then(userData => {
      this.currentUser = userData;
      this.initLinks();
    });
  }

  initLinks() {
    const links = [];
    if (this.currentUser.type === 'admin') {
      links.push({
        name: 'Đăng đơn hàng',
        url: '/order',
      }, {
        name: 'Chờ xét duyệt',
        url: '/requests',
      });
    }

    this.links = links;
  }

  logout() {
    const check = confirm('Bạn có muốn đăng xuất?');
    if (!check) {
      return false;
    }

    this.authService.doLogout()
    .then((res) => {
      this.router.navigate(['/login']);
    }, (error) => {
      console.log('Logout error', error);
    });
  }

}
